import type { CrudFilters } from '@refinedev/core';
import { SummaryAlertsBar } from '@/components/common/SummaryAlertsBar';
import { alertQueries, statQueries } from './summaryQueries';
import type { SummaryKey, SummaryQuery } from './summaryQueries';

interface DistributionPeriodAlertsProps {
  activeKey: SummaryKey | null;
  /** Page-level scope applied on top of every query's own filters. */
  scope?: CrudFilters;
  /** Click toggles the query's filter set; `null` clears it. */
  onSelect: (query: SummaryQuery | null) => void;
}

/** "Wymaga uwagi" bar for distribution periods. */
export const DistributionPeriodAlerts = ({
  activeKey,
  scope = [],
  onSelect,
}: DistributionPeriodAlertsProps) => (
  <SummaryAlertsBar<SummaryKey>
    resource="content_catalog.distribution_periods"
    labelPrefix="content_catalog.distribution_periods"
    alerts={alertQueries()}
    stats={statQueries()}
    activeKey={activeKey}
    scope={scope}
    onSelect={onSelect}
  />
);
